import { accountCenterApi } from '@/api/accountCenterClient';

let refreshPromise: Promise<boolean> | null = null;

// Dedupes concurrent 401s (from AuthProvider's cookie-expiry effect and any
// number of in-flight API calls) into a single refresh request, so callers
// racing during the token-expiry window all await the same outcome instead
// of each triggering — and redirecting on — their own refresh.
export function refreshAuth(): Promise<boolean> {
  if (!refreshPromise) {
    refreshPromise = accountCenterApi
      .post<{ refreshed: boolean }>('/auth/refresh')
      .then(({ data }) => data.refreshed)
      .catch(() => false)
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}
